import type { ComponentProps } from "react"

import { SlideoutMenu as UUISlideoutMenu } from "@/components/ui-kit/untitled/application/slideout-menus/slideout-menu"
import { cn } from "@/lib/utils"

type SlideoutMenuProps = ComponentProps<typeof UUISlideoutMenu>

// The vendored slideout overlay omits the z-50 that modals/modal.tsx sets, so on
// .app-canvas pages (where `.app-canvas > *` lifts page content to z-index:2) the
// panel renders behind the page. Default the overlay to z-50 to match the modal
// wrapper. The kit's Menu spreads `className` onto the overlay, so this lands
// where it's needed.
function SlideoutMenuRoot({ className, ...props }: SlideoutMenuProps) {
  return (
    <UUISlideoutMenu
      {...props}
      className={(state) =>
        cn(
          "z-50",
          typeof className === "function" ? className(state) : className,
        )
      }
    />
  )
}

// Cast to the kit's own type: its compound sub-component prop types
// (e.g. SlideoutHeaderProps) aren't exported, so an inferred type here can't be
// named in declaration emit (TS4023). Referencing the imported type sidesteps it.
const SlideoutMenu = Object.assign(SlideoutMenuRoot, {
  Trigger: UUISlideoutMenu.Trigger,
  Content: UUISlideoutMenu.Content,
  Header: UUISlideoutMenu.Header,
  Footer: UUISlideoutMenu.Footer,
}) as typeof UUISlideoutMenu

export { SlideoutMenu }
